<section class="hero">
  <div class="container hero__inner position-relative z-1">
    <div class="row">
      <div class="col-12 col-lg-6 d-flex flex-column align-items-start">
        <h1 class="hero__title display-2 mb-3">Tagging your pets? That’s smart.</h1>
        <p class="hero__subtitle mb-4">
          A smart tag gives whoever finds your pet a direct way to reach you, helping you get back
          together faster than with a microchip alone.
        </p>
        <div class="d-flex flex-column flex-sm-row gap-3 mb-4 align-self-center align-self-sm-start">
          <button type="button" (click)="handleSmartTagCta()" class="btn ui-btn ui-btn--primary fw-bold">Get yours today</button>
          <a [routerLink]="[]" fragment="how-it-works" class="btn ui-btn ui-btn--outline-light fw-bold">See how it works</a>
        </div>
        <app-trustbox class="align-self-center align-self-sm-start" theme="dark"></app-trustbox>
      </div>
    </div>
  </div>

  <div class="hero__image-col">
    <div class="hero__image-wrapper">
      <img
        src="/assets/images/identibase/smartTag/smart-tag-woman-with-dog.webp"
        alt="Person lying on a bed with their dog, looking at their phone"
        class="hero__image">
    </div>
  </div>
</section>

<section class="intro">
  <div class="container">
    <div class="row align-items-center gy-5">
      <div class="col-12 col-lg-6 d-flex flex-column align-items-start">
        <h2 class="intro__title display-3 mb-3">A quicker way back to each other.</h2>
        <p class="intro__body mb-4">
          Using the scannable smart tag, anyone who finds your pet can contact you straight away,
          share their location and send you their details. No vet visit. No unnecessary delay.
        </p>
        <button type="button" (click)="handleSmartTagCta()" class="btn ui-btn ui-btn--primary fw-bold align-self-center align-self-sm-start">Order Now</button>
      </div>
      <div class="col-12 col-lg-6">
        <div class="intro__image-wrapper">
          <img
            src="/assets/images/identibase/smartTag/app-activate-smart-tag.webp"
            alt="Activating a smart tag in the identi app"
            class="intro__image">
          <app-background-icon
            src="/assets/images/icons/notification.svg"
            [top]="18"
            [left]="5"
            [width]="105"
          />
        </div>
      </div>
    </div>
  </div>
</section>

<section class="reassurance">
  <div class="container position-relative">

    <div class="row align-items-center gy-5 position-relative z-1">
      <div class="col-12 col-lg-6 d-flex flex-column align-items-start">
        <h2 class="reassurance__title display-3 mb-3">Skip the shouting their name bit.</h2>
        <p class="reassurance__body mb-4">
          Give yourself peace of mind knowing your pet is easy to identify and just a scan away from
          helping you find your way back to each other.
        </p>
        <button type="button" (click)="handleSmartTagCta()" class="btn ui-btn ui-btn--primary fw-bold align-self-center align-self-sm-start">Order Now</button>
      </div>
      <div class="col-12 col-lg-6">
        <div class="reassurance__image-wrapper position-relative">
          <app-background-icon
            class="reassurance__icon--behind"
            src="/assets/images/icons/ball-cream.svg"
            [top]="0"
            [left]="3"
            [width]="140"
            [hideOnMobile]="true"
          />
          <img
            src="/assets/images/identibase/smartTag/smart-tag-man-holding-cat.webp"
            alt="Person outdoors holding their cat"
            class="reassurance__image w-100">
          <app-background-icon
            src="/assets/images/icons/toy-cream.svg"
            [top]="-2"
            [left]="93"
            [width]="140"
            [hideOnMobile]="true"
          />
          <app-background-icon
            src="/assets/images/icons/dog-cream.svg"
            [top]="94"
            [left]="3"
            [width]="185"
            [hideOnMobile]="true"
          />
        </div>
      </div>
    </div>

  </div>
</section>

<section id="how-it-works" class="steps">
  <div class="container position-relative z-1">

    <h2 class="steps__title display-3 text-center mb-5">How does it work?</h2>

    <div class="row mb-4">
      <div class="col-12 col-lg-4">
        <h3 class="steps__intro-title fs-5 mb-3">Getting started is quick and hassle-free</h3>
        <p class="steps__intro-body mb-0">
          Order your pet’s smart tag, register it in minutes, and enjoy the peace of mind that comes
          with making it easier for them to find their way back to you.
        </p>
      </div>
    </div>

    <div class="steps__track" #stepsCanvas>

      <!-- connector svg -->
      <svg
        class="steps__connector d-none d-lg-block"
        [attr.viewBox]="'0 0 ' + canvasWidth + ' ' + canvasHeight"
        [attr.width]="canvasWidth"
        [attr.height]="canvasHeight"
        fill="none"
        aria-hidden="true">
        <path *ngFor="let d of connectorPaths" [attr.d]="d" class="steps__connector-path" />
      </svg>

      <div class="row align-items-center justify-content-center steps__step">
        <div class="col-12 col-lg-5">
          <div class="steps__tags d-flex align-items-center justify-content-center">
            <img src="/assets/images/identibase/smartTag/pink-smart-tag-front.webp" alt="" aria-hidden="true" class="steps__tag steps__tag--1" (load)="onStepImageLoad()">
            <img src="/assets/images/identibase/smartTag/biscuit-smart-tag-front.webp" alt="" aria-hidden="true" class="steps__tag steps__tag--2">
            <img src="/assets/images/identibase/smartTag/indigo-smart-tag-front.webp" alt="Identi smart tags in three colours" class="steps__tag steps__tag--3">
          </div>
        </div>
        <div class="col-12 col-lg-4 steps__card-col steps__card-col--right">
          <app-home-step-card-v2
            [number]="1"
            title="Customise your Tag"
            body="Choose your tag style and add your pet's details to create their unique smart tag."
            badgePosition="right">
          </app-home-step-card-v2>
          <span #stepAnchor class="steps__anchor steps__anchor--out-right"></span>
        </div>
      </div>

      <div class="row align-items-center justify-content-center flex-lg-row-reverse steps__step">
        <div class="col-12 col-lg-5">
          <img
            src="/assets/images/identibase/smartTag/smart-tag-profile-preview.webp"
            alt="Setting up a pet profile in the identi app"
            class="steps__image w-100 my-4 my-md-0"
            (load)="onStepImageLoad()">
        </div>
        <div class="col-12 col-lg-4 steps__card-col steps__card-col--left">
          <span #stepAnchor class="steps__anchor steps__anchor--in-left"></span>
          <app-home-step-card-v2
            [number]="2"
            title="Set up your pet's profile"
            body="Add your pet's details in the identi app."
            badgePosition="left">
          </app-home-step-card-v2>
          <span #stepAnchor class="steps__anchor steps__anchor--out-left"></span>
        </div>
      </div>

      <div class="row align-items-center justify-content-center steps__step">
        <div class="col-12 col-lg-5">
          <img
            src="/assets/images/identibase/smartTag/smart-tag-scan-qr-code.webp"
            alt="Scanning a pet's smart tag with a phone"
            class="steps__image w-100 my-4 my-md-0"
            (load)="onStepImageLoad()">
        </div>
        <div class="col-12 col-lg-4 steps__card-col steps__card-col--right">
          <span #stepAnchor class="steps__anchor steps__anchor--in-right"></span>
          <app-home-step-card-v2
            [number]="3"
            title="Choose what to share"
            body="Choose what finders can see, and switch on Privacy Mode if you'd prefer to keep your phone number hidden."
            badgePosition="right">
          </app-home-step-card-v2>
        </div>
      </div>

    </div>
  </div>

  <app-background-icon src="/assets/images/icons/cat.svg" [top]="12" [left]="88" [width]="180" [opacity]="0.25" [hideOnMobile]="true" />
  <app-background-icon src="/assets/images/icons/paw.svg" [top]="22" [left]="97" [width]="150" [opacity]="0.25" [hideOnMobile]="true" />
  <app-background-icon src="/assets/images/icons/bone.svg" [top]="33" [left]="22" [width]="150" [opacity]="0.25" [hideOnMobile]="true" />
  <app-background-icon src="/assets/images/icons/kennel.svg" [top]="45" [left]="5" [width]="170" [opacity]="0.25" [hideOnMobile]="true" />
  <app-background-icon src="/assets/images/icons/carry_crate.svg" [top]="52" [left]="76" [width]="170" [opacity]="0.25" [hideOnMobile]="true" />
  <app-background-icon src="/assets/images/icons/treats.svg" [top]="65" [left]="15" [width]="150" [opacity]="0.25" [hideOnMobile]="true" />
  <app-background-icon src="/assets/images/icons/pet_birthday.svg" [top]="92" [left]="85" [width]="170" [opacity]="0.25" [hideOnMobile]="true" />
</section>

<section class="styles">
  <div class="container position-relative">

    <app-background-icon
      src="/assets/images/icons/pet_birthday-cream.svg"
      [top]="18"
      [left]="97"
      [width]="170"
      [hideOnMobile]="true"
    />
    <app-background-icon
      src="/assets/images/icons/cat-cream.svg"
      [top]="52"
      [left]="1"
      [width]="180"
      [hideOnMobile]="true"
    />

    <div class="row justify-content-center text-center position-relative z-1">
      <div class="col-12 col-lg-7">
        <h2 class="styles__title display-3 mb-3">Pick your style</h2>
        <p class="styles__subtitle mb-5">
          Flexible, waterproof and built for pet life. Our silicone tags come in a range of colours,
          so your pet can wear their personality on their collar.
        </p>
      </div>
    </div>

    <div class="row align-items-end justify-content-center gy-4 position-relative z-1">
      <div class="col-12 col-md-4">
        <div class="styles__swatch styles__swatch--pink">
          <div class="styles__tile">
            <img
              src="/assets/images/identibase/smartTag/pink-silicone-tag.webp"
              alt="Paw Pad Pink silicone smart tag"
              class="styles__tag">
          </div>
          <span class="styles__label">Paw Pad Pink</span>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="styles__swatch styles__swatch--indigo styles__swatch--featured">
          <div class="styles__tile">
            <img
              src="/assets/images/identibase/smartTag/indigo-silicone-tag.webp"
              alt="Identi Indigo silicone smart tag"
              class="styles__tag">
          </div>
          <span class="styles__label">Identi Indigo</span>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="styles__swatch styles__swatch--biscuit">
          <div class="styles__tile">
            <img
              src="/assets/images/identibase/smartTag/biscuit-silicone-tag.webp"
              alt="Biscuit silicone smart tag"
              class="styles__tag">
          </div>
          <span class="styles__label">Biscuit</span>
        </div>
      </div>
    </div>

    <div class="row text-center gy-5 mt-4 position-relative z-1">
      <div class="col-6 col-lg-3">
        <span class="styles__feature-icon d-inline-flex align-items-center justify-content-center mb-3">
          <img src="/assets/images/icons/droplet.svg" width="20" height="20" alt="" aria-hidden="true">
        </span>
        <h3 class="styles__feature-title fs-5 mb-2">100% Waterproof</h3>
        <p class="styles__feature-body mb-0">Rain, puddles, swims; no problem.</p>
      </div>
      <div class="col-6 col-lg-3">
        <span class="styles__feature-icon d-inline-flex align-items-center justify-content-center mb-3">
          <img src="/assets/images/icons/zap.svg" width="20" height="20" alt="" aria-hidden="true">
        </span>
        <h3 class="styles__feature-title fs-5 mb-2">Super Flexible</h3>
        <p class="styles__feature-body mb-0">Soft, bendy silicone that’s gentle on fur and made for everyday wear.</p>
      </div>
      <div class="col-6 col-lg-3">
        <span class="styles__feature-icon d-inline-flex align-items-center justify-content-center mb-3">
          <img src="/assets/images/icons/palette.svg" width="20" height="20" alt="" aria-hidden="true">
        </span>
        <h3 class="styles__feature-title fs-5 mb-2">Multiple Colours</h3>
        <p class="styles__feature-body mb-0">Pick the one that suits your pet’s personality.</p>
      </div>
      <div class="col-6 col-lg-3">
        <span class="styles__feature-icon d-inline-flex align-items-center justify-content-center mb-3">
          <img src="/assets/images/icons/mobile-phone.svg" width="16" height="22" alt="" aria-hidden="true">
        </span>
        <h3 class="styles__feature-title fs-5 mb-2">Smart Inside</h3>
        <p class="styles__feature-body mb-0">All the same clever tech, in a softer silicone design.</p>
      </div>
    </div>

    <div class="text-center position-relative z-1">
      <button type="button" (click)="handleSmartTagCta()" class="btn ui-btn ui-btn--primary fw-bold mt-5">Order Now</button>
    </div>

  </div>
</section>

<section class="features">
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-12 col-lg-8">
        <h2 class="features__title display-3 mb-3">Ready for whatever pet life brings.</h2>
        <p class="features__subtitle mb-5">
          Whether it’s an unexpected adventure or a sudden escape, register your pet today and help
          make getting them home quicker and easier.
        </p>
      </div>
    </div>

    <div class="features__card-frame">
      <app-background-icon
        src="/assets/images/icons/pet_birthday-pink.svg"
        [top]="6"
        [left]="-2"
        [width]="175"
        [hideOnMobile]="true"
      />
      <app-background-icon
        src="/assets/images/icons/dog-pink.svg"
        [top]="32"
        [left]="103"
        [width]="200"
        [hideOnMobile]="true"
      />
      <app-background-icon
        src="/assets/images/icons/cat-pink.svg"
        [top]="66"
        [left]="-3"
        [width]="180"
        [hideOnMobile]="true"
      />
      <app-background-icon
        src="/assets/images/icons/paw-pink.svg"
        [top]="80"
        [left]="102"
        [width]="150"
        [hideOnMobile]="true"
      />

      <div class="features__card">
        <p class="features__label mb-0">Included plan features</p>

        <div class="features__group">
          <h3 class="features__group-title mb-0">Smart tag with geolocation alerts</h3>
          <div class="features__row">
            <span class="features__row-label">QR code smart tag &amp; geolocation alerts</span>
            <ng-container *ngTemplateOutlet="tick"></ng-container>
          </div>
          <div class="features__row">
            <span class="features__row-label">Pet &amp; keeper profile</span>
            <ng-container *ngTemplateOutlet="tick"></ng-container>
          </div>
        </div>

        <div class="features__group">
          <h3 class="features__group-title mb-0">Backed by identi's pet protection</h3>
          <div class="features__row">
            <span class="features__row-label">Alerts when your pet's microchip is scanned*</span>
            <ng-container *ngTemplateOutlet="tick"></ng-container>
          </div>
          <div class="features__row">
            <span class="features__row-label">Lost pet helpline</span>
            <span class="features__row-value">24/7</span>
          </div>
        </div>

        <div class="features__group">
          <h3 class="features__group-title mb-0">Proactive support to get your pet home faster</h3>
          <div class="features__row">
            <span class="features__row-label">Instant missing pet poster</span>
            <ng-container *ngTemplateOutlet="tick"></ng-container>
          </div>
          <div class="features__row">
            <span class="features__row-label">Alerts to local rescues, vets, wardens, police</span>
            <ng-container *ngTemplateOutlet="tick"></ng-container>
          </div>
          <div class="features__row">
            <span class="features__row-label">Alerts to local keepers</span>
            <ng-container *ngTemplateOutlet="tick"></ng-container>
          </div>
          <div class="features__row">
            <span class="features__row-label">Social media post creation &amp; sharing</span>
            <ng-container *ngTemplateOutlet="tick"></ng-container>
          </div>
        </div>

        <div class="features__group">
          <h3 class="features__group-title mb-0">Premium perks for busy lifestyles</h3>
          <div class="features__row">
            <span class="features__row-label">Multi-pet protection (up to 5 pets)</span>
            <ng-container *ngTemplateOutlet="tick"></ng-container>
          </div>
          <div class="features__row">
            <span class="features__row-label">24/7 access to Televet appointments</span>
            <ng-container *ngTemplateOutlet="tick"></ng-container>
          </div>
          <div class="features__row">
            <span class="features__row-label">Wellbeing calendar &amp; reminders</span>
            <ng-container *ngTemplateOutlet="tick"></ng-container>
          </div>
          <div class="features__row">
            <span class="features__row-label">Holiday mode</span>
            <ng-container *ngTemplateOutlet="tick"></ng-container>
          </div>
          <div class="features__row">
            <span class="features__row-label">Privacy mode</span>
            <ng-container *ngTemplateOutlet="tick"></ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center">
      <button type="button" (click)="handleSmartTagCta()" class="btn ui-btn ui-btn--primary fw-bold mt-5">Get yours today</button>
    </div>

  </div>
</section>

<section class="support">
  <div class="container position-relative">

    <div class="row justify-content-center text-center">
      <div class="col-12 col-lg-9">
        <h2 class="support__title display-3 mb-5">Support for the everyday worries.</h2>
      </div>
    </div>

    <div class="row align-items-center gy-4 position-relative z-1">
      <div class="col-12 col-lg-7 d-flex flex-column gap-4">

        <div class="support__card">
          <div class="d-flex align-items-center gap-3 mb-3">
            <span class="support__card-icon d-flex align-items-center justify-content-center">
              <img src="/assets/images/icons/stethoscope.svg" width="20" height="20" alt="" aria-hidden="true">
            </span>
            <h3 class="support__card-title fs-5 mb-0">Vet Connect</h3>
          </div>
          <p class="support__card-body mb-0">
            As a Locator member, you’ll have access to Vet Connect, giving you 24/7 video and
            telephone consultations with veterinary professionals from the comfort of home. From
            upset stomachs to unusual behaviour, help is there whenever you need it.
          </p>
        </div>

        <div class="support__card">
          <div class="d-flex align-items-center gap-3 mb-3">
            <span class="support__card-icon d-flex align-items-center justify-content-center">
              <img src="/assets/images/icons/calendar-check.svg" width="20" height="20" alt="" aria-hidden="true">
            </span>
            <h3 class="support__card-title fs-5 mb-0">Wellbeing Calendar</h3>
          </div>
          <p class="support__card-body mb-0">
            Keep all the important dates for your pet in one place, and we’ll send you a reminder
            when they’re coming up, from grooming and vaccinations to any appointments you add
            yourself.
          </p>
        </div>

      </div>
      <div class="col-12 col-lg-5">
        <div class="support__image-wrapper position-relative">
          <app-background-icon
            src="/assets/images/icons/bandage-cream.svg"
            [top]="4"
            [left]="4"
            [width]="170"
            [hideOnMobile]="true"
          />
          <img
            src="/assets/images/identibase/smartTag/smart-tag-cat.webp"
            alt="Cat sitting outdoors wearing a smart tag on its collar"
            class="support__image w-100">
          <app-background-icon
            src="/assets/images/icons/document-check-cream.svg"
            [top]="97"
            [left]="97"
            [width]="170"
            [hideOnMobile]="true"
          />
        </div>
      </div>
    </div>

  </div>
</section>

<!-- circle checkmark template -->
<ng-template #tick>
  <span class="features__tick" role="img" aria-label="Included">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="currentColor" />
      <path
        d="M6 12.5L10 16.5L18 8"
        stroke="white"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>
</ng-template>
